var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            "auto-complete": "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("联合导购管理系统")]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                ref: "username",
                attrs: {
                  clearable: "",
                  placeholder: "账号",
                  name: "username",
                  type: "text",
                  tabindex: "1",
                  "auto-complete": "on",
                },
                model: {
                  value: _vm.loginForm.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "username", $$v)
                  },
                  expression: "loginForm.username",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                key: _vm.passwordType,
                ref: "password",
                attrs: {
                  type: _vm.passwordType,
                  placeholder: "密码",
                  name: "password",
                  tabindex: "2",
                  "auto-complete": "on",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleLogin($event)
                  },
                },
                model: {
                  value: _vm.loginForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v)
                  },
                  expression: "loginForm.password",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class":
                        _vm.passwordType === "password" ? "eye" : "eye-open",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", margin: "20px 0" },
              attrs: { loading: _vm.loading, type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin($event)
                },
              },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            center: "",
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog_box" }, [
            _c("div", { staticClass: "title_box fc" }, [
              _vm._v("请选择您要查看的后台"),
            ]),
            _vm._v(" "),
            _vm.isAppData
              ? _c("div", [
                  _vm.appData.length > 0
                    ? _c("div", { staticClass: "fc" }, [
                        _c(
                          "div",
                          { staticClass: "app_box mt20" },
                          _vm._l(_vm.appData, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.appId,
                                staticClass: "item_app_box fc pointer",
                                class:
                                  _vm.selectApp === item.appId
                                    ? "selected_app_box"
                                    : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.onSelectApp(item)
                                  },
                                },
                              },
                              [
                                _c("div", [
                                  _c("div", { staticClass: "fc" }, [
                                    _c("img", {
                                      staticStyle: {
                                        width: "60px",
                                        height: "60px",
                                        "border-radius": "12px",
                                      },
                                      attrs: { src: item.icon, alt: "" },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fc",
                                      staticStyle: {
                                        "font-size": "18px",
                                        color: "#474245",
                                        "font-weight": "bold",
                                        "margin-top": "6px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.appName) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "30px",
                            "font-weight": "600",
                            "margin-top": "120px",
                          },
                        },
                        [
                          _c("div", { staticClass: "fc" }, [
                            _vm._v("当前您还没有相关的后台管理权限"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "fc" }, [
                            _vm._v("请联系管理员处理!"),
                          ]),
                        ]
                      ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fc" }, [
            _c(
              "span",
              {
                staticStyle: { "padding-bottom": "0px" },
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "300px", height: "54px" },
                    on: { click: _vm.onCancel },
                  },
                  [_vm._v("取 消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "300px", height: "54px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onVerify()
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }